window.g2 = require('@antv/g2');
window.react = require('react');
window.reactDom = require('react-dom');
